import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useNavigationControls } from '../NavigationContext';
import { contentContainer, sideNavContent } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var Content = function Content(_ref) {
  var _routesAndRedirects$r, _routesAndRedirects$r2;

  var notFoundComponent = _ref.notFoundComponent,
      homeRoute = _ref.homeRoute,
      topNavigation = _ref.topNavigation;

  var _useNavigationControl = useNavigationControls(),
      allRoutes = _useNavigationControl.allRoutes;

  var TopNav = topNavigation;

  var _useState = useState({
    routes: [],
    redirects: []
  }),
      _useState2 = _slicedToArray(_useState, 2),
      routesAndRedirects = _useState2[0],
      setRoutesAndRedirects = _useState2[1];

  useEffect(function () {
    var routes = [];
    var redirects = [];
    allRoutes.forEach(function (el) {
      if (el !== null && el !== void 0 && el.component && el !== null && el !== void 0 && el.url) routes.push(el);
      if (el !== null && el !== void 0 && el.redirectsTo && el !== null && el !== void 0 && el.url) redirects.push(el);
    });
    setRoutesAndRedirects({
      routes: routes,
      redirects: redirects
    });
  }, [allRoutes]);
  return ___EmotionJSX("section", {
    css: contentContainer
  }, TopNav && ___EmotionJSX(TopNav, null), ___EmotionJSX("article", {
    css: sideNavContent
  }, ___EmotionJSX(Switch, null, (_routesAndRedirects$r = routesAndRedirects.routes) === null || _routesAndRedirects$r === void 0 ? void 0 : _routesAndRedirects$r.map(function (route, i) {
    return ___EmotionJSX(Route, {
      key: "".concat(route.url, "-").concat(i),
      exact: route.exact,
      path: route.url,
      component: route.component
    });
  }), (_routesAndRedirects$r2 = routesAndRedirects.redirects) === null || _routesAndRedirects$r2 === void 0 ? void 0 : _routesAndRedirects$r2.map(function (el) {
    return ___EmotionJSX(Redirect, {
      key: el.url,
      exact: true,
      from: el.url,
      to: el.redirectsTo
    });
  }), homeRoute && ___EmotionJSX(Redirect, {
    exact: true,
    from: "/",
    to: homeRoute
  }), notFoundComponent && ___EmotionJSX(Route, {
    component: notFoundComponent
  }))));
};

Content.propTypes = {
  notFoundComponent: PropTypes.func,
  homeRoute: PropTypes.string,
  topNavigation: PropTypes.any
};
export default Content;